import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";

import KDAUSLogo from "../assets/kdaus.png";
import KDAUKLogo from "../assets/kdauk.png";
import { Link } from "react-router-dom";

const ResponsiveAppBar = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <AppBar
            id="header"
            className="app-bar-responsive"
            position="static"
            color="white"
        >
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
                    >
                        <a
                            href="https://www.kennedysdisease.org/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={KDAUSLogo}
                                alt="Kennedy's Disease Association US Logo"
                            />
                        </a>
                        <div className="appbar-img-container logo-uk">
                            <a
                                href="http://kd-uk.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    className=""
                                    src={KDAUKLogo}
                                    alt="Kennedy's Disease Association UK Logo"
                                />
                            </a>
                        </div>
                    </Typography>

                    <Box
                        sx={{
                            flexGrow: 1,
                            display: { xs: "flex", md: "none" },
                        }}
                    >
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: "block", md: "none" },
                            }}
                        >
                            <MenuItem>
                                <Link to="/" onClick={handleCloseNavMenu}>
                                    Home
                                </Link>
                            </MenuItem>
                            <MenuItem>
                                <Link to="news" onClick={handleCloseNavMenu}>
                                    News
                                </Link>
                            </MenuItem>
                            <MenuItem>
                                <Link to="photos" onClick={handleCloseNavMenu}>
                                    Photos and Videos
                                </Link>
                            </MenuItem>
                            <MenuItem>
                                <Link to="events" onClick={handleCloseNavMenu}>
                                    Events
                                </Link>
                            </MenuItem>
                            <MenuItem>
                                <Link
                                    to="volunteer"
                                    onClick={handleCloseNavMenu}
                                >
                                    Sign Up
                                </Link>
                            </MenuItem>
                        </Menu>
                    </Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{
                            flexGrow: 1,
                            display: { xs: "flex", md: "none" },
                        }}
                    >
                        <a
                            href="https://www.kennedysdisease.org/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={KDAUSLogo}
                                alt="Kennedy's Disease Association US Logo"
                            />
                        </a>
                        <div className="appbar-img-container logo-uk">
                            <a
                                href="http://kd-uk.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={KDAUKLogo}
                                    alt="Kennedy's Disease Association UK Logo"
                                />
                            </a>
                        </div>
                    </Typography>
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: { xs: "none", md: "flex" },
                        }}
                    >
                        <MenuItem>
                            <Link to="/">
                                <Typography
                                    sx={{
                                        my: 2,
                                        color: "primary",
                                        display: "block",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Home
                                </Typography>
                            </Link>
                        </MenuItem>
                        <MenuItem>
                            <Link to="news">
                                <Typography
                                    sx={{
                                        my: 2,
                                        color: "primary",
                                        display: "block",
                                        fontWeight: "bold",
                                    }}
                                >
                                    News
                                </Typography>
                            </Link>
                        </MenuItem>
                        <MenuItem>
                            <Link to="photos">
                                <Typography
                                    sx={{
                                        my: 2,
                                        color: "primary",
                                        display: "block",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Photos and Video
                                </Typography>
                            </Link>
                        </MenuItem>
                        <MenuItem>
                            <Link to="events">
                                <Typography
                                    sx={{
                                        my: 2,
                                        color: "primary",
                                        display: "block",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Events
                                </Typography>
                            </Link>
                        </MenuItem>
                        <MenuItem>
                            <Link to="volunteer">
                                <Typography
                                    sx={{
                                        my: 2,
                                        color: "primary",
                                        display: "block",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Sign Up
                                </Typography>
                            </Link>
                        </MenuItem>
                    </Box>

                    <Button
                        href="https://www.kennedysdisease.org/kda-campaigns"
                        target="_blank"
                        rel="noreferrer"
                        variant="contained"
                        color="secondary"
                        size="large"
                    >
                        Donate
                    </Button>
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default ResponsiveAppBar;
